import './components/filter_list';
import './components/search_list_item';
import './index.scss';
import 'components/campaigns/interventions/leaderboard';
import 'components/generic_list_item';
import 'styles/components/_alerts.scss';
import 'styles/components/_navs.scss';
import 'styles/components/_pagination.scss';

(() => {
  const searchParams = new URLSearchParams(window.location.search);
  const dataPage = $('.q-search-page').data();
  const totalResults = $('.q-search-page')
    .find('[data-total-results]')
    .data('totalResults');

  $(document).ready(() => {
    UserTracker.emit('event', {
      eventName: 'global search viewed',
      data: {
        query: searchParams.get('q'),
        'request path': window.location.pathname,
        'referral path': document?.referrer
          ? new URL(document.referrer).pathname
          : '',
        'search type': 'odin',
        'source project': 'odin',
        'search result count': totalResults
      }
    });

    window.dataLayer.push({
      event: 'search',
      search_term: searchParams.get('q'),
      without_result: !dataPage.searchResults
    });
  });
})();
